export default __webpack_public_path__ + "static/media/4.5b9f0c82.jpg";